import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import PremiumFolderDataIcon from '../_partials/PremiumFolderDataIcon';
import shortenNumber from '@wix/da-ds/pkg/utils/shortenNumber';
import folderDropdownDesktopStyles from './FolderDropdownDesktop.scss';
const FolderInfo = ({ folder })=>{
    const { t } = useTranslation();
    var _folder_totalItemCount;
    const deviationCount = (_folder_totalItemCount = folder.totalItemCount) !== null && _folder_totalItemCount !== void 0 ? _folder_totalItemCount : folder.size;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(folderDropdownDesktopStyles['info'], !!folder.parentId && folderDropdownDesktopStyles['subfolder-info'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: folderDropdownDesktopStyles['title']
    }, /*#__PURE__*/ React.createElement(PremiumFolderDataIcon, {
        premiumFolderData: folder === null || folder === void 0 ? void 0 : folder.premiumFolderData,
        size: IconSize.SMALL,
        className: folderDropdownDesktopStyles['premium-folder-icon']
    }), folder.name), /*#__PURE__*/ React.createElement("div", {
        className: folderDropdownDesktopStyles['stats']
    }, t('gallectionDropdown.folder.stats.artworks', {
        formattedCount: shortenNumber(deviationCount),
        count: deviationCount
    })));
};
FolderInfo.displayName = 'FolderInfo';
export default FolderInfo;
